<template>
  <el-tag v-if="progress" size="medium" :type="cssClass"
  >{{ progressLabel }}
  </el-tag>
</template>

<script>
export default {
  name: "hc-quychequydinh-progress",
  props: ["progress"],

  computed: {
    cssClass() {
      switch (this.progress) {
        case "LATE":
          return "danger";
        case "ON_TIME":
          return "success";
        default:
          return "";
      }
    },

    progressLabel() {
      switch (this.progress) {
        case "LATE":
          return "Chậm tiến độ";
        case "ON_TIME":
          return "Đúng hạn";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-progress.vue